// Account
//  -- User
import Account from "@/components/account/Account";
// -- Admin
import AdminFormAuthentication from "@/components/account/admin/authentication/FormAuthentication";
import FormAuthentication from "@/components/account/authentication/FormAuthentication";
import RecoveryPassword from "@/components/account/password/RecoveryPassword";
import UpdatePassword from "@/components/account/password/UpdatePassword";
import ActivationSignup from "@/components/account/signup/ActivationSignup";
import ExpiredSignup from "@/components/account/signup/ExpiredSignup";
import FormSignup from "@/components/account/signup/FormSignup";
import SuccessSignup from "@/components/account/signup/SuccessSignup";
import AdminShowApplication from "@/components/admin/application/show/AdminShowApplication";
import AdminDashboard from "@/components/admin/dashboard/AdminDashboard";
// Application
import Application from "@/components/application/Application";
import NewApplication from "@/components/application/new/NewApplication";
import ShowApplication from "@/components/application/show/ShowApplication";
import AdminsList from "@/components/configurations/admins/List";
import ApplicationList from "@/components/configurations/application/List";
// Configurations
import ApplicationTypesList from "@/components/configurations/application_types/List";
import CustomersList from "@/components/configurations/customers/List";
import DocumentTypesList from "@/components/configurations/document_types/List";
import UpdateEntity from "@/components/configurations/entity/Update";
import EnviromentalStudyTypesList from "@/components/configurations/enviromental_study_type/List";
import TypologiesList from "@/components/configurations/typology/List";
import TypologyShow from "@/components/configurations/typology/show/TypologyShow";
// Admin
import LegalTermsText from "@/components/legal_terms/LegalTermsText";
import LegalTermsAutoInfracao from "@/components/legal_terms/LegalTermsAutoInfracao";
import LegalTermsImaPlus from "@/components/legal_terms/LegalTermsImaPlus";
import LegalTermsNossaPraia from "@/components/legal_terms/LegalTermsNossaPraia";
import LegalTermsIMADenuncie from "@/components/legal_terms/LegalTermsIMADenuncie";

// Subpoenas
import NewSubpoena from "@/components/subpoenas/new/NewSubpoena";
import AdminSubpoenas from "@/views/AdminSubpoenas";
// Subpoenas
import Tabs from "@/views/Tabs";
import Vue from "vue";
import Router from "vue-router";

// import AdminListApplication from '@/components/admin/application/list/AdminListApplication';

Vue.use(Router);

const hasToken = () => localStorage.getItem("access_token") != null;

const userType = () => {
  if (localStorage.getItem("user") != null) {
    return JSON.parse(localStorage.getItem("user")).user_type;
  }
  return false;
};

const checkUserAuthentication = (to, from, next) => {
  if (hasToken() && userType() === "User") {
    next();
    return;
  }
  localStorage.removeItem("access_token");
  localStorage.removeItem("user");
  next({ path: "/requerente/conta/entrar" });
};

const checkAdminAuthentication = (to, from, next) => {
  if (hasToken() && userType() === "Admin") {
    next();
    return;
  }
  localStorage.removeItem("access_token");
  localStorage.removeItem("user");
  next({ path: "/admin/conta/entrar" });
};

const router = new Router({
  // mode: 'history',
  routes: [
    {
      path: "/",
      redirect: {
        path: "/requerente/requerimentos/lista",
      },
    },
    {
      path: "/admin",
      redirect: {
        path: "/admin/dashboard",
      },
    },

    //  -------------ADMIN SIDE---------------
    {
      path: "/admin/dashboard",
      component: AdminDashboard,
      name: "AdminDashboard",
      beforeEnter: checkAdminAuthentication,
      meta: { userType: "Admin", userAlias: "admin" },
    },
    {
      path: "/admin/conta",
      component: Account,
      meta: { userType: "Admin", userAlias: "admin" },
      children: [
        {
          name: "AdminSignIn",
          path: "entrar",
          meta: { userType: "Admin", userAlias: "admin" },
          beforeEnter: (to, from, next) => {
            if (hasToken()) {
              next({ path: "/admin/requerimentos" });
              return;
            }
            next();
          },
          component: AdminFormAuthentication,
        },
        {
          path: "senha/alterar",
          meta: { userType: "Admin", userAlias: "admin" },
          component: UpdatePassword,
        },
      ],
    },
    {
      path: "/admin/requerimentos",
      component: Application,
      meta: { userType: "Admin", userAlias: "admin" },
      redirect: {
        path: "/admin/requerimentos/lista",
      },
      children: [
        {
          path: "lista",
          beforeEnter: checkAdminAuthentication,
          meta: { userType: "Admin", userAlias: "admin" },
          component: Tabs,
          name: "ApplicationsAndSubpoenasForAdmin",
        },
        {
          path: ":id/visualizar",
          meta: { userType: "Admin", userAlias: "admin" },
          component: AdminShowApplication,
        },
        {
          path: "nova-intimacao",
          meta: { userType: "Admin", userAlias: "admin" },
          component: NewSubpoena,
          name: "Nova Intimação",
        },
      ],
    },
    {
      path: "/admin/intimacoes",
      beforeEnter: checkAdminAuthentication,
      meta: { userType: "Admin", userAlias: "admin" },
      component: AdminSubpoenas,
      name: "AdminSubpoenasList",
    },
    {
      path: "/admin/configuracao",
      component: Application,
      redirect: {
        name: "TypologyList",
      },
      children: [
        {
          path: "document_types",
          component: DocumentTypesList,
          name: "DocumentTypesList",
        },
        {
          path: "application_types",
          component: ApplicationTypesList,
          name: "ApplicationTypesList",
        },
        {
          path: "typologies",
          component: TypologiesList,
          name: "TypologyList",
        },
        {
          path: "typology/:id",
          component: TypologyShow,
          name: "TypologyShow",
        },
        {
          path: "enviromental_study_type",
          component: EnviromentalStudyTypesList,
          name: "EnviromentalStudyTypeList",
        },
        {
          path: "users",
          component: CustomersList,
          name: "CustomersList",
        },
        {
          path: "employees",
          component: AdminsList,
          name: "AdminsList",
        },
        {
          path: "applications",
          component: ApplicationList,
          name: "ApplicationList",
        },
        {
          path: ":id/visualizar",
          component: AdminShowApplication,
          name: "AdminShowApplication",
          meta: { userType: "Admin", userAlias: "admin" },
        },
        {
          path: "entity",
          component: UpdateEntity,
          name: "UpdateEntity",
        },
      ],
    },
    //  -------------REQUERENTE SIDE---------------
    {
      path: "/requerente/conta",
      component: Account,
      children: [
        {
          meta: { userType: "User", userAlias: "requerente" },
          path: "entrar",
          beforeEnter: (to, from, next) => {
            if (hasToken()) {
              next({ path: "/requerente/requerimentos/lista" });
              return;
            }
            next();
          },
          component: FormAuthentication,
          name: "requerenteSignIn",
        },
        {
          path: "cadastrar",
          component: FormSignup,
        },
        {
          path: "cadastrar/sucesso",
          component: SuccessSignup,
        },
        {
          path: "cadastrar/ativacao/:confirmation_token",
          component: ActivationSignup,
        },
        {
          path: "cadastrar/expirado",
          component: ExpiredSignup,
        },
        {
          path: "senha/recuperar",
          component: RecoveryPassword,
        },
        {
          path: "senha/alterar",
          component: UpdatePassword,
        },
      ],
    },
    {
      path: "/requerente/requerimentos",
      component: Application,
      meta: { userType: "User", userAlias: "requerente" },
      redirect: {
        name: "Requerimentos e Intimações",
      },
      children: [
        {
          path: "lista",
          component: Tabs,
          beforeEnter: checkUserAuthentication,
          meta: { userType: "User", userAlias: "requerente" },
          name: "Requerimentos e Intimações",
        },
        {
          path: "novo",
          component: NewApplication,
          name: "Novo Requerimento",
        },
        {
          path: ":id/visualizar",
          name: "ExibirRequerimento",
          component: ShowApplication,
          props: true,
        },
      ],
    },
    {
      path: "/termos",
      component: LegalTermsText,
      name: "LegalTermsText",
    },
    {
      path: "/termos-auto-infracao",
      component: LegalTermsAutoInfracao,
      name: "LegalTermLegalTermsAutoInfracaosText",
    },
    {
      path: "/termos-ima-plus",
      component: LegalTermsImaPlus,
      name: "LegalTermsImaPlus",
    },
    {
      path: "/termos-nossapraia",
      component: LegalTermsNossaPraia,
      name: "LegalTermsNossaPraia",
    },
    {
      path: "/termos-ima-denuncie",
      component: LegalTermsIMADenuncie,
      name: "LegalTermsIMADenuncie",
    },
    // {
    //   path: '/configuraca/typologies',
    //   component: TypologiesList,
    //   name: 'Tipologia',
    // },
  ],
});

export default router;

